import { buildChartOptions } from '@configurations/campaignAnalytics/timeToFirstVisitChart';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartCard } from '../ChartCard';
import { EditableChartProps } from './chartProps';

type TimeToFirstVisitProps = EditableChartProps;

const TimeToFirstVisit = (props: TimeToFirstVisitProps) => {
  const { report, ...chartCardProps } = props;

  return (
    <ChartCard
      title="Time to First Visit"
      description={`${props.campaignName} (${props.campaignId})`}
      report={report.timeToFirstVisitByDay}
      {...chartCardProps}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={buildChartOptions(report.timeToFirstVisitByDay.data)}
      />
    </ChartCard>
  );
};

export default TimeToFirstVisit;
